exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Withdrawal_audit[data-v-80de2174]{padding:20px 20px 40px 20px}", ""]);

// exports
